<template>
  <v-app>
    <h2 v-if="apiClientIsNull"></h2>
    <template v-else>
      <router-view name="app" />
      <router-view name="other" />
    </template>
  </v-app>
</template>

<script>
import Vue from "vue";

export default {
  name: "App",
  data: () => ({
    apiClientIsNull: true
  }),
  created() {
    const OpenAPIClientAxios = require("openapi-client-axios").default;
    const api = new OpenAPIClientAxios({
      definition: "http://93.170.73.27/api/openapi.json",
      axiosConfigDefaults: {
        // baseURL: "http://" + window.location.host.replace(":8081", ""),
        baseURL: "http://" + '93.170.73.27',
        timeout: 10000,
        params: {
          filter_date: new Date().toJSON().slice(0, 10),
        },
      },
    });

    api.init().then(() => {
      Vue.prototype.$original = api
      Vue.prototype.$api = api.client;
      this.apiClientIsNull = false
    })

  },
  methods: {
    setDefaultHeader(user) {
      this.$axios.defaults.headers.common["Authorization"] =
        "Bearer " + user.access;
    },
  },
};
</script>
